{
  "name": "modulair_webpage",
  "version": "0.1.2",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --configuration=development",
    "start:det": "ng serve --configuration=production",
    "start:es": "ng serve --configuration=energyshift",
    "build:det": "ng build --configuration=production",
    "build:es": "ng build --configuration=energyshift",
    "build:development": "ng build --configuration=development",
    "watch": "ng build --watch --configuration development",
    "test": "ng test"
  },
  "prettier": {
    "overrides": [
      {
        "files": "*.html",
        "options": {
          "parser": "angular"
        }
      }
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^21.1.3",
    "@angular/compiler": "^21.1.3",
    "@angular/core": "^21.1.3",
    "@angular/forms": "^21.1.3",
    "@angular/platform-browser": "^21.1.3",
    "@angular/router": "^21.1.3",
    "@auth0/angular-jwt": "^5.2.0",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-free": "^7.0.0",
    "@fortawesome/free-solid-svg-icons": "^7.0.0",
    "@primeuix/themes": "^1.2.3",
    "@tailwindcss/postcss": "^4.1.11",
    "chart.js": "^4.5.0",
    "chartjs-adapter-date-fns": "^3.0.0",
    "chartjs-plugin-annotation": "^3.1.0",
    "chartjs-plugin-zoom": "^2.2.0",
    "postcss": "^8.5.6",
    "primeicons": "^7.0.0",
    "primeng": "^21.1.1",
    "rxjs": "~7.8.0",
    "socket.io-client": "^4.8.1",
    "tailwindcss": "^4.1.18",
    "tailwindcss-primeui": "^0.6.1",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular/build": "^21.1.3",
    "@angular/cli": "^21.1.3",
    "@angular/compiler-cli": "^21.1.3",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.8.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.3",
    "typescript": "~5.9.3"
  }
}
